<main class="auth">

  <!-- ============ Hero ============ -->
  <header class="auth__hero">
    <div class="auth__hero-media"></div>
    <div class="auth__hero-scrim"></div>
    <div class="auth__hero-inner">
      <span class="auth__mark">
        <% if ( logoUrl ) { %>
        <img class="auth__mark-logo" src="<%= logoUrl %>" alt="<%= house %>" />
        <% } else { %>
        <svg width="46" height="46" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs><clipPath id="loginFrame"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath></defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#F2E9DC" stroke-width="4.5"></rect>
          <g clip-path="url(#loginFrame)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#D6C59D" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#F2E9DC" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#D6C59D" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
        <% } %>
      </span>
      <div class="auth__hero-title"><%= house %></div>
      <div class="auth__hero-region"><%= region %></div>
    </div>
  </header>

  <!-- ============ Form ============ -->
  <section class="auth__body">
    <p class="belturo-eyebrow auth__eyebrow"><%= _lcs( 'Willkommen zurück' ) %></p>
    <h1 class="auth__title"><%= _lcs( 'Schön, dass du' ) %> <em><%= _lcs( 'da bist.' ) %></em></h1>

    <form class="auth__form" autocomplete="on" novalidate>
      <div class="field">
        <label class="field__label" for="email"><%= _lcs( 'E-Mail' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--mail"></i></span>
          <input class="field__input" id="email" name="email" type="email" inputmode="email"
                 autocomplete="username" placeholder="name@example.com" required />
        </div>
      </div>

      <div class="field">
        <label class="field__label" for="password"><%= _lcs( 'Passwort' ) %></label>
        <div class="field__control">
          <span class="field__icon"><i class="icon icon--lock"></i></span>
          <input class="field__input" id="password" name="password" type="password"
                 autocomplete="current-password" placeholder="••••••••" required />
          <button class="field__toggle" type="button" id="togglePw" aria-label="<%= _lcs( 'Passwort anzeigen' ) %>" aria-pressed="false">
            <i class="icon icon--eye"></i>
          </button>
        </div>
      </div>

      <div class="auth__row-right">
        <a class="auth__link" href="#/password-forgotten" data-id="forgot"><%= _lcs( 'Passwort vergessen?' ) %></a>
      </div>

      <p class="auth__error" data-id="login-error" role="alert" hidden></p>

      <button class="btn btn--primary btn--lg btn--block" type="submit">
        <%= _lcs( 'Anmelden' ) %> <i class="icon icon--arrow-right"></i>
      </button>
    </form>

    <div class="auth__divider"><span><%= _lcs( 'oder' ) %></span></div>

    <button class="btn btn--secondary btn--lg btn--block" type="button" data-id="guest">
      <i class="icon icon--qr-code"></i> <%= _lcs( 'Als Gast fortfahren' ) %>
    </button>

    <p class="auth__switch">
      <%= _lcs( 'Noch kein Konto?' ) %> <a class="auth__link auth__link--strong" href="#" data-id="to-signup"><%= _lcs( 'Registrieren' ) %></a>
    </p>

    <div class="auth__legal">
      <a href="#"><%= _lcs( 'Datenschutz' ) %></a><span class="auth__legal-dot">·</span><a href="#"><%= _lcs( 'AGB' ) %></a>
    </div>
  </section>

</main>
